"use strict";

/* check if body has scrollbar */
if ($('body').outerHeight() > $(window).outerHeight() && !is_mobile('any')) {
  $('body').addClass('has-scrollbar');
} else {
  $('body').removeClass('has-scrollbarr');
}
$(window).resize(function () {
  if ($('body').outerHeight() > $(window).outerHeight() && !is_mobile('any')) {
    $('body').addClass('has-scrollbar');
  } else {
    $('body').removeClass('has-scrollbarr');
  }
});

/* autosize */
autosize($('textarea'));

/* is mobile */
function is_mobile(method) {
  switch (method) {
    case 'Android':
      return navigator.userAgent.match(/Android/i);
    case 'BlackBerry':
      return navigator.userAgent.match(/BlackBerry/i);
    case 'iOS':
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    case 'Opera':
      return navigator.userAgent.match(/Opera Mini/i);
    case 'Windows':
      return navigator.userAgent.match(/IEMobile/i);
    case 'any':
      return is_mobile('Android') || is_mobile('BlackBerry') || is_mobile('iOS') || is_mobile('Opera') || is_mobile('Windows');
  }
}

/* validation methods */
$.validator.addMethod('email', function (value, element) {
  return is_email(value);
}, 'Please enter a valid email address.');

/* language switcher */
$('.wpml-ls-current-language > a').on('click', function (e) {
  e.preventDefault();
  if (!$(this).hasClass('is-active')) {
    $(this).addClass('is-active');
    $('.wpml-ls-current-language .sub-menu').stop().slideDown(250);
  } else {
    $(this).removeClass('is-active');
    $('.wpml-ls-current-language .sub-menu').stop().slideUp(250);
  }
});
$('.wpml-ls-current-language').on('clickoutside', function () {
  $('.wpml-ls-current-language > a').removeClass('is-active');
  $('.wpml-ls-current-language .sub-menu').slideUp(250);
});
$('.wpml-ls-current-language .sub-menu a').on('click', function () {
  $('.wpml-ls-current-language > a').removeClass('is-active');
  $('.wpml-ls-current-language .sub-menu').slideUp(250);
});

/* mobile menu */
$('.js-hamburger').on('click', function (e) {
  e.preventDefault();
  e.stopPropagation();
  $('body').toggleClass('is-mobile-menu-visible');
});
$('.js-header').bind('clickoutside', function () {
  $('body').removeClass('is-mobile-menu-visible');
});
$(window).on('resize', function () {
  $('body').addClass('is-resizing');
  setTimeout(function () {
    $('body').removeClass('is-resizing');
  }, 100);
});

/* popup */
$('.js-popup-open').on('click', function (e) {
  e.preventDefault();
  var id = $(this).data('id');
  $('.js-popup[data-id="' + id + '"]').fadeIn(500);
});
$('.js-popup-close').on('click', function (e) {
  e.preventDefault();
  $(this).parents('.js-popup').fadeOut(500);
  if ($(this).parents('.js-popup').data('id') == 'newsletter-popup') {
    Cookies.set('newsletter-closed', 'true', {
      expires: 7
    });
  }
});

/* newsletter popup */
$(window).on('load', function () {
  if (Cookies.get('newsletter-closed') != 'true' && Cookies.get('newsletter-signed-up') != 'true') {
    setTimeout(function () {
      $('.js-popup[data-id="newsletter-popup"]').fadeIn(500);
    }, 3000);
  }
});

/* validation */
var newsletter_validation = {
  rules: {
    name: {
      required: true
    },
    email: {
      required: true,
      email: true
    }
  },
  highlight: function highlight(element, errorClass, validClass) {
    $(element).addClass(errorClass);
    $(element).removeClass(validClass);
  },
  unhighlight: function unhighlight(element, errorClass, validClass) {
    $(element).addClass(validClass);
    $(element).removeClass(errorClass);
  },
  errorPlacement: function errorPlacement(error, element) {},
  submitHandler: function submitHandler(form) {
    $(form).find('*[type="submit"]').attr('disabled', true); // disable submit

    $(form).ajaxSubmit({
      url: admin_ajax_url,
      data: {
        action: 'newsletter_subscribe'
      },
      success: function success(response) {
        response = $.parseJSON(response);
        $(form).find('*[type="submit"]').attr('disabled', false); // enable submit

        $(form).find('.js-message').hide(); // hide message
        $(form).find('.js-message').html(newsletter_messages[response.status]); // add message
        $(form).find('.js-message').fadeIn(250); // show message

        if (response.status == 'success' || response.status == 'exists') {
          $(form)[0].reset(); // reset form

          Cookies.set('newsletter-signed-up', 'true', {
            expires: 365
          }); // set cookie
        }
      }
    });
  },

  errorClass: 'not-valid',
  validClass: 'valid',
  errorElement: 'label',
  ignore: ':hidden',
  focusInvalid: false
  // onsubmit: false,
  // onfocusout: false,
  // onkeyup: false,
  // onclick: false
};

$('.js-newsletter').each(function () {
  $(this).validate(newsletter_validation);
});
var login_form = $('.js-platform-login');
login_form.ajaxForm({
  url: admin_ajax_url,
  data: {
    action: 'platform_login'
  },
  beforeSubmit: function beforeSubmit() {
    login_form.find('*[type="submit"]').attr('disabled', true);
  },
  error: function error() {
    login_form.find('*[type="submit"]').attr('disabled', false);
    login_form.find('.not-valid').removeClass('not-valid');
    login_form.find('.u-form-error').remove();
    login_form.find('.u-form-message').remove();
    alert('Please try again later');
  },
  success: function success(response) {
    response = $.parseJSON(response);
    login_form.find('*[type="submit"]').attr('disabled', false);
    login_form.find('.not-valid').removeClass('not-valid');
    login_form.find('.u-form-error').remove();
    login_form.find('.u-form-message').remove();
    if (response.success != true) {
      if (response.errors.length > 0) {
        response.errors.forEach(function (error) {
          // display errors
          if (login_form.find('*[name="' + error[0] + '"]').is(':checkbox')) {
            login_form.find('*[name="' + error[0] + '"]').addClass('not-valid');
            login_form.find('*[name="' + error[0] + '"]').parents('.u-form-checkbox').after('<p class="u-form-error checkbox">' + error[1] + '</p>');
          } else {
            login_form.find('*[name="' + error[0] + '"]').parents('.row').addClass('not-valid');
            login_form.find('*[name="' + error[0] + '"]').after('<p class="u-form-error">' + error[1] + '</p>');
          }
        });
      } else {
        // display error message
        login_form.append('<p class="u-form-message error">' + response.message + '</p>');
      }
    } else {
      // reload page
      location.reload();
    }
  }
});
var password_change_form = $('.js-platform-password-change');
password_change_form.ajaxForm({
  url: admin_ajax_url,
  data: {
    action: 'platform_password_change'
  },
  beforeSubmit: function beforeSubmit() {
    password_change_form.find('*[type="submit"]').attr('disabled', true);
  },
  error: function error() {
    password_change_form.find('*[type="submit"]').attr('disabled', false);
    password_change_form.find('.not-valid').removeClass('not-valid');
    password_change_form.find('.u-form-error').remove();
    password_change_form.find('.u-form-message').remove();
    alert('Please try again later');
  },
  success: function success(response) {
    response = $.parseJSON(response);
    password_change_form.find('*[type="submit"]').attr('disabled', false);
    password_change_form.find('.not-valid').removeClass('not-valid');
    password_change_form.find('.u-form-error').remove();
    password_change_form.find('.u-form-message').remove();
    if (response.success != true) {
      if (response.errors.length > 0) {
        response.errors.forEach(function (error) {
          // display errors
          if (password_change_form.find('*[name="' + error[0] + '"]').is(':checkbox')) {
            password_change_form.find('*[name="' + error[0] + '"]').addClass('not-valid');
            password_change_form.find('*[name="' + error[0] + '"]').parents('.u-form-checkbox').after('<p class="u-form-error checkbox">' + error[1] + '</p>');
          } else {
            password_change_form.find('*[name="' + error[0] + '"]').parents('.row').addClass('not-valid');
            password_change_form.find('*[name="' + error[0] + '"]').after('<p class="u-form-error">' + error[1] + '</p>');
          }
        });
      } else {
        // display error message
        password_change_form.append('<p class="u-form-message error">' + response.message + '</p>');
      }
    } else {
      // display success message
      password_change_form[0].reset();
      password_change_form.append('<p class="u-form-message success">' + response.message + '</p>');
    }
  }
});
var password_reset_form = $('.js-platform-password-reset');
password_reset_form.ajaxForm({
  url: admin_ajax_url,
  data: {
    action: 'platform_password_reset'
  },
  beforeSubmit: function beforeSubmit() {
    password_reset_form.find('*[type="submit"]').attr('disabled', true);
  },
  error: function error() {
    password_reset_form.find('*[type="submit"]').attr('disabled', false);
    password_reset_form.find('.not-valid').removeClass('not-valid');
    password_reset_form.find('.u-form-error').remove();
    password_reset_form.find('.u-form-message').remove();
    alert('Please try again later');
  },
  success: function success(response) {
    response = $.parseJSON(response);
    password_reset_form.find('*[type="submit"]').attr('disabled', false);
    password_reset_form.find('.not-valid').removeClass('not-valid');
    password_reset_form.find('.u-form-error').remove();
    password_reset_form.find('.u-form-message').remove();
    if (response.success != true) {
      if (response.errors.length > 0) {
        response.errors.forEach(function (error) {
          // display errors
          if (password_reset_form.find('*[name="' + error[0] + '"]').is(':checkbox')) {
            password_reset_form.find('*[name="' + error[0] + '"]').addClass('not-valid');
            password_reset_form.find('*[name="' + error[0] + '"]').parents('.u-form-checkbox').after('<p class="u-form-error checkbox">' + error[1] + '</p>');
          } else {
            password_reset_form.find('*[name="' + error[0] + '"]').parents('.row').addClass('not-valid');
            password_reset_form.find('*[name="' + error[0] + '"]').after('<p class="u-form-error">' + error[1] + '</p>');
          }
        });
      } else {
        // display error message
        password_reset_form.append('<p class="u-form-message error">' + response.message + '</p>');
      }
    } else {
      // display success message
      password_reset_form[0].reset();
      password_reset_form.append('<p class="u-form-message success">' + response.message + '</p>');
    }
  }
});
var register_form = $('.js-platform-register');
register_form.ajaxForm({
  url: admin_ajax_url,
  data: {
    action: 'platform_register'
  },
  beforeSubmit: function beforeSubmit() {
    register_form.find('*[type="submit"]').attr('disabled', true);
  },
  error: function error() {
    register_form.find('*[type="submit"]').attr('disabled', false);
    register_form.find('.not-valid').removeClass('not-valid');
    register_form.find('.u-form-error').remove();
    register_form.find('.u-form-message').remove();
    alert('Please try again later');
  },
  success: function success(response) {
    response = $.parseJSON(response);
    register_form.find('*[type="submit"]').attr('disabled', false);
    register_form.find('.not-valid').removeClass('not-valid');
    register_form.find('.u-form-error').remove();
    register_form.find('.u-form-message').remove();
    if (response.success != true) {
      if (response.errors.length > 0) {
        response.errors.forEach(function (error) {
          // display errors
          if (register_form.find('*[name="' + error[0] + '"]').is(':checkbox')) {
            register_form.find('*[name="' + error[0] + '"]').addClass('not-valid');
            register_form.find('*[name="' + error[0] + '"]').parents('.u-form-checkbox').after('<p class="u-form-error checkbox">' + error[1] + '</p>');
          } else {
            register_form.find('*[name="' + error[0] + '"]').parents('.row').addClass('not-valid');
            register_form.find('*[name="' + error[0] + '"]').after('<p class="u-form-error">' + error[1] + '</p>');
          }
        });
      } else {
        // display error message
        register_form.append('<p class="u-form-message error">' + response.message + '</p>');
      }
    } else {
      // display success message
      register_form[0].reset();
      register_form.append('<p class="u-form-message success">' + response.message + '</p>');
    }
  }
});
jQuery(document).ready(function ($) {
  /* add custom checkboxes to checkout */
  if ($('form.woocommerce-checkout').length > 0) {
    woo_add_custom_checkboxes();
    setTimeout(function () {
      woo_add_custom_checkboxes();
    }, 1000);
  }
  $(document.body).on('updated_checkout', function () {
    woo_add_custom_checkboxes();
  });
  function woo_add_custom_checkboxes() {
    // dotpay
    $('form.woocommerce-checkout label.dotpay_agreements:first-child').addClass('custom-checkbox');
    $('form.woocommerce-checkout label.dotpay_agreements:first-child').wrapInner('<div>');
    $('form.woocommerce-checkout label.dotpay_agreements:first-child div').before($('form.woocommerce-checkout label.dotpay_agreements:first-child input'));
    $('form.woocommerce-checkout label.dotpay_agreements:first-child input').after('<span class="checkmark"></span>');

    // mailchimp
    $('form.woocommerce-checkout .woocommerce-mailchimp-opt-in label').addClass('custom-checkbox');
    $('form.woocommerce-checkout .woocommerce-mailchimp-opt-in label .checkmark').remove();
    $('form.woocommerce-checkout .woocommerce-mailchimp-opt-in label input').after('<span class="checkmark"></span>');
  }

  /* shipping address */

  /* MULTI SHOP
  $('#ship-to-different-address-checkbox').on('change', function() {
  	if (!$('#shipping_country').hasClass('select2-hidden-accessible')) {
  		$('#shipping_country option:first-child').remove();
  		$('#shipping_country').select2();
  	}
  });
  */

  /* country shipping note */
  if ($('html').attr('lang') == 'pl-PL') {
    $('#billing_country').after('<p class="country-shipping-note">Jeżeli chcesz zamówić książkę poza Polskę, napisz do nas - <a href="mailto:sklep@earlystage.pl">sklep@earlystage.pl</a></p>');
  } else {
    $('#billing_country').after('<p class="country-shipping-note">If you want your book to be delivered outside Poland, let us know by email - <a href="mailto:shop@earlystage.pl">shop@earlystage.pl</a></p>');
  }

  /* terms & conditions link */
  $('body').on('click', '.woocommerce-terms-and-conditions-link', function (e) {
    window.open($(this).attr('href'));
    return false;
  });
});
//# sourceMappingURL=app.js.map
